export default () => ({
    seeker_fields: [],
});
